import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { AppRoutes } from './router';

/**
 * The production browser data router. The underlying tree is a JSX
 * `<Routes>` (see `router.tsx`) so it can be driven by a MemoryRouter
 * in tests without data-router side effects.
 */
export const routes: RouteObject[] = [{ path: '*', element: <AppRoutes /> }];

export const appRouter = createBrowserRouter(routes);
